import React from 'react';
import CaseForm from './CaseForm';
import SectionHeader from './SectionHeader'
import Container from '@mui/material/Container';
import Divider from '@mui/material/Divider';
import { HOST } from '../components/config';
const AddCase = () => {
  const handleOnSubmit = (caseInfo) => {
      try {
        caseInfo['tenant_id'] = 1
        fetch(HOST + '/api/cases/?org_id=' + localStorage.getItem('org_id'),
        {   
          "method": "POST",
          "headers" : { 
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('token')
            },  
          "body": JSON.stringify(caseInfo)
         })
        .then((res) => res.json())
        .then((json) => {
          if (json['id'])
            document.location.href = './cases/' + json['id']  
       })
      } catch (err) {
        console.log(err);
      } finally {
      }
  };

  const handleBack = () => {
    document.location.href = './cases'
  }

  return (
    <React.Fragment>
    <Container disableGutters={false} > 
      <SectionHeader title='New Case' mt={4}  />
      <Divider  />
      <CaseForm handleOnSubmit={handleOnSubmit}  handleBack={handleBack} />
    </Container>
    </React.Fragment>
  );
};

export default AddCase;
